import LScreen from "@components/LScreen";
import { getActiveTab } from "@hooks/useActiveTab";
import { router } from "expo-router";

const GoBack = () => {
  if (router.canGoBack()) {
    router.back();
  } else {
    router.navigate(`/(app)/(tabs)/${getActiveTab()}`);
  }

  return <LScreen />;
};

export default GoBack;
